import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

type MangopayConsentContext = {
  showMangopayConsent: boolean;
  setShowMangopayConsent: Dispatch<SetStateAction<boolean>>;
};

export const MangopayConsentContext =
  createContext<MangopayConsentContext | null>(null);

export const useMangopayConsentContext = () =>
  useContext(MangopayConsentContext);
